import { render, staticRenderFns } from "./Zipcodes.vue?vue&type=template&id=6224d98e"
import script from "./Zipcodes.vue?vue&type=script&lang=js"
export * from "./Zipcodes.vue?vue&type=script&lang=js"
import style0 from "./Zipcodes.vue?vue&type=style&index=0&id=6224d98e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports